import { render, staticRenderFns } from "./CoTextReadmore.vue?vue&type=template&id=0d8b0dd4&"
import script from "./CoTextReadmore.vue?vue&type=script&lang=ts&"
export * from "./CoTextReadmore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports